/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/*
* This is a copy of the file found in dashboard-livewidget
*/
export default {
	Radar: {
		visId: 'com.ibm.vis.rave2bundleradar',
		CATEGORY: 'categories',
		CYCLICAL: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		NUMERIC_COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Area: {
		visId: 'com.ibm.vis.rave2bundlearea',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	StackedArea: {
		visId: 'com.ibm.vis.rave2bundlearea',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Bar: {
		visId: 'com.ibm.vis.rave2bundlebar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical',
		TARGET_LINE: 'target'
	},
	ClusteredBar: {
		visId: 'com.ibm.vis.rave2bundlebar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical',
		TARGET_LINE: 'target'
	},
	StackedBar: {
		visId: 'com.ibm.vis.rave2bundlestackedbar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Bubble: {
		visId: 'com.ibm.vis.ravebubble',
		X: 'x',
		Y: 'y',
		SIZE: 'size',
		COLOR: 'color',
		POINTS :'categories',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Column: {
		visId: 'com.ibm.vis.rave2bundlecolumn',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical',
		TARGET_LINE: 'target'
	},
	ClusteredColumn: {
		visId: 'com.ibm.vis.rave2bundlecolumn',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical',
		TARGET_LINE: 'target'
	},
	StackedColumn: {
		visId: 'com.ibm.vis.rave2bundlestackedcolumn',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Crosstab: {
		visId: 'crosstab',
		VALUE: 'values',
		COLUMN_HIERARCHY: 'column_level1',
		ROW_HIERARCHY: 'row_level1'
	},
	Heatmap: {
		visId: 'com.ibm.vis.rave2heat',
		ROW: 'categories',
		COLUMN: 'series',
		COLOR: 'color',
		SIZE: 'size',
		POINTS: 'points',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Line: {
		visId: 'com.ibm.vis.rave2line',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	ClusteredLine: {
		visId: 'com.ibm.vis.rave2line',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	DualAxis: {
		visId: 'com.ibm.vis.rave2bundlecomposite',
		CATEGORY: 'categories',
		Y1: 'lineValue',
		Y2: 'columnValue',
		COLUMN_COLOR: 'columnColor',
		LINE_COLOR: 'lineColor',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Tiledmap: {
		visId: 'com.ibm.vis.rave2bundletiledmap',
		REGION_LOCATION: 'locations',
		REGION_COLOR: 'locationColor',
		POINT_LOCATION: 'pointLocations',
		POINT_COLOR: 'pointColor',
		POINT_SIZE: 'pointSize',
		COORDINATE_LATITUDE: 'latlongLocations.latitude',
		COORDINATE_LONGITUDE: 'latlongLocations.longitude',
		COORDINATE_COLOR: 'latlongColor',
		COORDINATE_SIZE: 'latlongSize',
		COORDINATE_LABEL: 'latlongLocations.caption'
	},
	PackedBubble: {
		visId: 'com.ibm.vis.rave2bundlepackedbubble',
		CATEGORY: 'categories',
		COLOR: 'color',
		SIZE: 'size',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	HierarchicalPackedBubble: {
		visId: 'com.ibm.vis.rave2bundlehierarchicalpackedbubble',
		HIERARCHY: 'categories',
		COLOR: 'color',
		SIZE: 'size',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Network: {
		visId: 'com.ibm.vis.rave2network',
		TO: 'series',
		FROM: 'categories',
		LINK_WIDTH: 'values',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Pie: {
		visId: 'com.ibm.vis.rave2bundlepie',
		CATEGORY: 'categories',
		VALUE: 'values',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	HierarchicalPie: {
		visId: 'com.ibm.vis.rave2bundlepie',
		HIERARCHY: 'categories',
		VALUE: 'values',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Point: {
		visId: 'com.ibm.vis.rave2point',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	ClusteredPoint: {
		visId: 'com.ibm.vis.rave2point',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Dial: {
		visId: 'com.ibm.vis.rave2bundleradialbar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Scatter: {
		visId: 'com.ibm.vis.ravescatter',
		X: 'x',
		Y: 'y',
		COLOR: 'color',
		POINTS: 'categories',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Singleton: {
		visId: 'summary',
		VALUE: 'actual'
	},
	KPI: {
		visId: 'kpi',
		ACTUAL: 'actual',
		PLANNED: 'goal',
		CATEGORY: 'sparkline.time'
	},
	List: {
		visId: 'JQGrid',
		ANY: 'grid_cols'
	},
	Treemap: {
		visId: 'com.ibm.vis.rave2bundletreemap',
		HIERARCHY: 'categories',
		CATEGORY: 'categories',
		SIZE: 'size',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Wordle: {
		visId:'com.ibm.vis.rave2bundlewordcloud',
		CATEGORY: 'categories',
		SIZE: 'size',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Spiral: {
		visId: 'com.ibm.vis.spiral',
		TARGET: 'values'
	},
	DriverAnalysis: {
		visId: 'com.ibm.vis.rave2comet',
		TARGET: 'values'
	},
	DecisionTree: {
		visId: 'com.ibm.vis.decisiontree',
		TARGET: 'values'
	},
	Sunburst: {
		visId: 'com.ibm.vis.sunburst',
		TARGET: 'values'
	},
	Bullet: {
		visId: 'com.ibm.vis.rave2bundlebullet',
		PLANNED: 'goal',
		ACTUAL: 'actual',
		MINIMUM: 'min',
		MIDDLE: 'mid',
		MAXIMUM: 'max',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Marimekko: {
		visId: 'com.ibm.vis.rave2marimekko',
		BARS: 'categories',
		LENGTH: 'values',
		WIDTH: 'width',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Mentions: {
		visId: 'com.ibm.vis.snippetlistbundle',
		POSTID: 'postId',
		AUTHORNAME: 'authorName',
		AUTHORNICKNAME: 'authorNickname',
		AUTHORPROFILEURL: 'authorProfileUrl',
		AUTHORURL: 'authorProfileUrl',
		AUTHORAVATAR: 'authorAvatar',
		SITETITLE: 'siteTitle',
		TITLE: 'title',
		DATE: 'date',
		SOURCE: 'source',
		URL: 'url',
		CONVERSATIONSIZE: 'conversationSize',
		MENTIONID: 'mentionId',
		SNIPPET: 'snippet',
		SENTIMENT: 'sentiment'
	},
	ConversationCluster: {
		visId: 'com.ibm.vis.convoclusterbundle',
		CLUSTER: 'cluster',
		KEYWORD: 'keyword',
		WEIGHT: 'weight',
		BREAKDOWN: 'breakdown',
		MENTIONS: 'mentions'
	},
	Waterfall: {
		visId: 'com.ibm.vis.rave2bundlewaterfall',
		CATEGORY: 'categories',
		CUMULATIVE: 'values',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	BoxPlot: {
		visId: 'com.ibm.vis.rave2bundleboxplot',
		CATEGORY: 'key',
		VALUE: 'values',
		BARS: 'categories',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	}
}
